import React from "react";
import PropTypes from 'prop-types';

const GroupList = (props) => (
    <ul className="list-group">
        {
            props.list.map((item) => {
                return <li key={item.id} className="list-group-item">
                    <div className="store-card-list__image-container flex__shrink-fixed border-radius-large">
                        <div className={"row"}>
                            <div className={"col-md-3 col-sm-2 col-3"}>
                                {
                                    item.imageTag && item.imageTag != "" &&
                                    <div className="store-card-list__image-cover">
                                        <label className="store-card-list__tag tag tag__small tag__privacy text-uppercase text-weight-bolder">
                                            {item.imageTag}
                                        </label>
                                    </div>
                                }

                                <figure className="store-card-list__image card__image">
                                    <img src={item.image} alt={item.title} />
                                </figure>
                            </div>

                            <div className={"col-md-9 col-sm-10 col-9 merchant-description-container"}>
                                <summary className="store-card-list__summary padding-left-right-small">
                                    <h4 className="store-card-list__title text-size-bigger text-weight-bolder text-multiple-line text-max-3-line merchant-name">{item.marketplace_name || item.title}</h4>
                                    {
                                        item.subtitle.length > 0 &&
                                        <div>
                                            <h6 className="store-card-list__title text-weight-bolder text-omit__single-line subtitle-color">{item.subtitle}</h6>
                                        </div>
                                    }
                                    {
                                        item.tag.length > 0 &&
                                        <div className="store-card-list__title store-card-list__tags-wrapper padding-left-right-smaller">
                                            <span className="text-size-smaller store-card-list__tags-text text-omit__single-line">{item.tag.join()}</span>
                                        </div>
                                    }

                                    {
                                        item.distanceDisplay != "0.00 KM" &&
                                        <ul className="store-info">
                                            <li className="store-info__item text-middle">
                                                <i className="icon icon__smaller text-middle">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"></path><path d="M0 0h24v24H0z" fill="none"></path></svg>
                                                </i><span className="store-info__text text-size-smaller text-middle">{item.distanceDisplay}</span>
                                            </li>
                                        </ul>
                                    }
                                </summary>
                            </div>
                        </div>
                        <div className={"store-card-list__footer row align-middle mt-2"}>
                            <div className="col">
                                <div className="footer-content" style={{height: "36px"}}>
                                    {
                                        !item.facebookPageUrl ?
                                        <div className={"footer-content-item fb-info"}>&nbsp;</div>:
                                        <>
                                            <div className={"footer-content-item fb-info"} style={{cursor: "pointer"}} onClick={(e) => {
                                                e.stopPropagation()
                                                window.open(item.facebookPageUrl, "_blank")
                                                return false
                                            }}>
                                                <div className="fb-icon-wrapper">
                                                    <img src="https://order-lah.com/static/img/fb_logo_50.png" alt="Facebook Icon" style={{width: "32px", height: "32px" }} />
                                                </div>
                                                <div className="fb-page-name" style={{fontSize: "14px", fontWeight: "bold"}}>{item.facebookPageName || lang.check_out_our_fb}</div>
                                            </div>
                                        </>
                                    }
                                    <div className={"footer-content-item button-order-now"} style={{cursor: "pointer"}}>
                                        <div>
                                            <div><i className="fa fa-shopping-cart" /></div>
                                            <div style={{fontSize: "14px", fontWeight: "bold", maxLines: "1"}} onClick={(evt) => props.listClick(item)}>{(lang.order_now || "Order Now").toUpperCase()}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            })
        }
    </ul >
);

GroupList.propTypes = {
    list: PropTypes.array.isRequired
};

GroupList.defaultProps = {

};

export { GroupList };